export const PHONE_DISPLAY = "+91 89694 49945";
export const TEL_URL = "tel:+918969449945";
export const WA_URL = "https://wa.me/918969449945";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SERVICE_OPTIONS = [
    "New Lift Installation",
    "Maintenance / AMC",
    "Breakdown Service",
    "Repair",
    "Other",
];

export const CITY_OPTIONS = ["Patna", "Gaya", "Ranchi", "Other"];

export const INPUT_CLASS =
    "w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-[#0B1528] placeholder:text-slate-400 transition-[border-color,box-shadow] duration-200 focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/20";

export const buildWaQuoteUrl = ({ name, phone, city, service, message }) => {
    const lines = [
        "Hi K1 ELEVATOR'S, I would like a free quote.",
        name && `Name: ${name}`,
        phone && `Phone: ${phone}`,
        city && `City: ${city}`,
        service && `Service Required: ${service}`,
        message && `Message: ${message}`,
    ].filter(Boolean);
    return `${WA_URL}?text=${encodeURIComponent(lines.join("\n"))}`;
};

const img = (id, extra) =>
    `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&${extra}&q=80&auto=format&fit=crop`;

export const IMG = {
    lobby: img(
        "photo-1758448721149-aa0ce8e1b2c9",
        "ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBlbGV2YXRvciUyMGxvYmJ5fGVufDB8fHx8MTc5MDk1MDY1NHww&ixlib=rb-4.1.0&w=1800",
    ),
    capsule: img(
        "photo-1746702475459-89ff401cafd8",
        "ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBlbGV2YXRvciUyMGludGVyaW9yfGVufDB8fHx8MTc5MDk1MDY1NHww&ixlib=rb-4.1.0&w=1200",
    ),
    cabin: img(
        "photo-1735178181188-855a87e83dca",
        "ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBlbGV2YXRvciUyMGludGVyaW9yfGVufDB8fHx8MTc5MDk1MDY1NHww&ixlib=rb-4.1.0&w=1200",
    ),
    shaft: img(
        "photo-1600167990118-5ca20ea216fc",
        "ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBlbGV2YXRvciUyMGludGVyaW9yfGVufDB8fHx8MTc5MDk1MDY1NHww&ixlib=rb-4.1.0&w=1200",
    ),
    caliper: img(
        "photo-1581092160562-40aa08e78837",
        "ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxlbmdpbmVlciUyMG1haW50ZW5hbmNlJTIwdGVjaG5pY2FsJTIwaW5zcGVjdGlvbnxlbnwwfHx8fDE3OTA5NTA2NjN8MA&ixlib=rb-4.1.0&w=1200",
    ),
    machinery: img(
        "photo-1581092163144-b7ae3c00adbc",
        "ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxlbmdpbmVlciUyMG1haW50ZW5hbmNlJTIwdGVjaG5pY2FsJTIwaW5zcGVjdGlvbnxlbnwwfHx8fDE3OTA5NTA2NjN8MA&ixlib=rb-4.1.0&w=1200",
    ),
    team: img(
        "photo-1581094488379-6a10d04c0f04",
        "ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxlbmdpbmVlciUyMG1haW50ZW5hbmNlJTIwdGVjaG5pY2FsJTIwaW5zcGVjdGlvbnxlbnwwfHx8fDE3OTA5NTA2NjN8MA&ixlib=rb-4.1.0&w=1600",
    ),
};

export const LOCATIONS = [
    {
        city: "PATNA",
        state: "Bihar",
        address: "Nahar Per, Kothwan, Patna, Bihar, India",
        short: "Nahar Per, Kothwan, Patna, Bihar",
        testid: "city-card-patna",
    },
    {
        city: "GAYA",
        state: "Bihar",
        address: "Karmoni, Gaya, Bihar, India",
        short: "Karmoni, Gaya, Bihar",
        testid: "city-card-gaya",
    },
    {
        city: "RANCHI",
        state: "Jharkhand",
        address: "Harmu Chowk, Ranchi, Jharkhand, India",
        short: "Harmu Chowk, Ranchi, Jharkhand",
        testid: "city-card-ranchi",
    },
];

export const NAV_LINKS = [
    { to: "/", label: "Home", testid: "nav-link-home" },
    { to: "/services", label: "Services", testid: "nav-link-services" },
    { to: "/about", label: "About Us", testid: "nav-link-about" },
    { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];
